import { c as _c } from "react/compiler-runtime";
import { ENV, INITIAL_APP_URL } from '@/constants/config';
import useMutationObservable, { USE_MUTATION_OBSERVABLE_DEFAULT_OPTIONS } from '@/hooks/useMutationObserver';
import useResizeObserver from '@react-hook/resize-observer';
import { isDev as isDev_ } from '@winelidays/wld-tsx-2/utils';
import { useEffect, useLayoutEffect, useState } from 'react';
import * as rdd from 'react-device-detect';
import { INITIAL_APP_RECT_VALUE } from './app.const';
import AppContext from './app.context';
const MUTATION_OBSERVER_OPTIONS = {
    ...USE_MUTATION_OBSERVABLE_DEFAULT_OPTIONS,
    config: {
        ...USE_MUTATION_OBSERVABLE_DEFAULT_OPTIONS.config,
        attributeFilter: ['data-full-screen']
    },
    debounceTime: 100
};
const getIsWebPSupported = () => {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    return false;
};
const INITIAL_SCREEN_WIDTH = 1440.22222;
const AppProvider = t0 => {
    const $ = _c(24);
    const { children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = isDev_(ENV);
        $[0] = t1;
    }
    else {
        t1 = $[0];
    }
    const isDev = t1;
    const [appRect, setAppRect] = useState(INITIAL_APP_RECT_VALUE);
    const [screenWidth, setScreenWidth] = useState(INITIAL_SCREEN_WIDTH);
    const [screenHeight, setScreenHeight] = useState(INITIAL_SCREEN_WIDTH);
    const [appElement, setAppElement] = useState(null);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = node => {
            if (node !== null) {
                setAppElement(node);
            }
        };
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const appRef = t2;
    let t3;
    if ($[2] !== appElement) {
        t3 = appElement && rdd.browserName !== "none" ? rdd.browserName.toLowerCase() : "";
        $[2] = appElement;
        $[3] = t3;
    }
    else {
        t3 = $[3];
    }
    const browserName = t3;
    const appClassName = browserName ? `browser-${browserName}` : "";
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = getIsWebPSupported();
        $[4] = t4;
    }
    else {
        t4 = $[4];
    }
    const isWebPSupported = t4;
    let t5;
    let t6;
    if ($[5] !== appElement) {
        t5 = () => {
            if (appElement?.getBoundingClientRect) {
                setAppRect(appElement.getBoundingClientRect().toJSON());
                setScreenWidth(window.innerWidth);
                setScreenHeight(window.innerHeight);
            }
        };
        t6 = [appElement];
        $[5] = appElement;
        $[6] = t5;
        $[7] = t6;
    }
    else {
        t5 = $[6];
        t6 = $[7];
    }
    useLayoutEffect(t5, t6);
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = entry => {
            setAppRect(entry.target.getBoundingClientRect().toJSON());
            setScreenWidth(window.innerWidth);
            setScreenHeight(window.innerHeight);
        };
        $[8] = t7;
    }
    else {
        t7 = $[8];
    }
    useResizeObserver(appElement, t7);
    const handleMutation = _temp;
    useMutationObservable(appElement, handleMutation, MUTATION_OBSERVER_OPTIONS);
    let t8;
    let t9;
    if ($[9] !== appRect.height) {
        t8 = () => {
            const frameId = requestAnimationFrame(() => {
                if (window.top) {
                    window.top.postMessage({
                        wldEventName: "wld-resize",
                        wldIFrameSrc: INITIAL_APP_URL,
                        wldAppHeight: appRect.height
                    }, "*");
                }
            });
            return () => {
                cancelAnimationFrame(frameId);
            };
        };
        t9 = [appRect.height];
        $[9] = appRect.height;
        $[10] = t8;
        $[11] = t9;
    }
    else {
        t8 = $[10];
        t9 = $[11];
    }
    useEffect(t8, t9);
    let t10;
    if ($[12] !== appElement || $[13] !== appRect || $[14] !== browserName || $[15] !== screenHeight || $[16] !== screenWidth) {
        t10 = {
            ...appRect,
            screenWidth,
            screenHeight,
            isDev,
            isTouchDevice,
            isWebPSupported,
            appElement,
            browserName
        };
        $[12] = appElement;
        $[13] = appRect;
        $[14] = browserName;
        $[15] = screenHeight;
        $[16] = screenWidth;
        $[17] = t10;
    }
    else {
        t10 = $[17];
    }
    const contextValue = t10;
    let t11;
    if ($[18] !== appClassName || $[19] !== children) {
        t11 = <div id="app" className={appClassName} ref={appRef}>{children}</div>;
        $[18] = appClassName;
        $[19] = children;
        $[20] = t11;
    }
    else {
        t11 = $[20];
    }
    let t12;
    if ($[21] !== contextValue || $[22] !== t11) {
        t12 = <AppContext value={contextValue}>{t11}</AppContext>;
        $[21] = contextValue;
        $[22] = t11;
        $[23] = t12;
    }
    else {
        t12 = $[23];
    }
    return t12;
};
export default AppProvider;
function _temp() {
    const elements = Array.from(document.querySelectorAll("[data-full-screen=\"true\"]"));
    if (elements.length) {
        document.body.style.overflow = "hidden";
    }
    else {
        document.body.style.removeProperty("overflow");
    }
}
